import {Component, OnInit} from '@angular/core';
import {FormGroup} from '@angular/forms';
import {Subject} from 'rxjs';
import {BsModalRef, BsModalService} from 'ngx-bootstrap/modal';
import {language} from '../../../language/vn';
@Component({
  templateUrl: './docview.component.html'

})
export class DocViewComponent implements OnInit {
  public language = language;
  public frmGroup: FormGroup;
  public id: number = 0;
  private isDocView: number = 0;
  public isEdit: boolean = false;
  public isSuDung: boolean = true;
  private isMulti: boolean = false;
  private typeView: string = 'google';
  public submitValidate = false;
  public onClose: Subject<boolean>;
  public pdfSrc: String;
  public pdfMulti: Object[] = [];
  private images: String[] = [];
  private imageIndex: number = 0;


  constructor(public bsModalService: BsModalService,
              public _bsModalRef: BsModalRef,
  ) {
  }



  ngOnInit(): void {
    this.onClose = new Subject();
  }
  private getType( typeView: string, url: String )
  {
    this.images = [];
    this.typeView = (typeView.indexOf('.docx') !== -1 || typeView.indexOf('.doc') !== -1
      || typeView.indexOf('.rtf') !== -1
      || typeView.indexOf('.xls') !== -1
      || typeView.indexOf('.xlsx') !== -1) ? 'office' : 'google';
    if (typeView.toLowerCase().indexOf('.pdf') !== -1)
      this.isDocView = 1;

    if (typeView.toLowerCase().indexOf('.png') !== -1  ||
      typeView.toLowerCase().indexOf('.jpg') !== -1 ||
      typeView.toLowerCase().indexOf('.gif') !== -1 ||
      typeView.toLowerCase().indexOf('.jpeg') !== -1 || typeView.toLowerCase().indexOf('.tiff') !== -1
    )
    {
      this.isDocView = 2;
      this.images.push(url);
    }

  }
  public show(url: String, typeView: string)
  {
    this.isMulti = false;
    this.getType(typeView, url);
    this.pdfSrc = url;

  }
  public showMulti(files: Object[])
  {
    if (files !== null && files.length > 0)
    {
      this.getType(files[0]['name'], files[0]["url"]);
      this.pdfSrc = files[0]["url"];
    }
    this.isMulti = true;
    this.pdfMulti = files;
  }
  private showByFile(url: string)
  {
    const type  = this.pdfMulti.find(element => {
      return element['url'] === url;
    });
    this.getType(type['name'], url);
    this.pdfSrc = url;

  }
  public onConfirm(): void {

    this.onClose.next(true);
    this._bsModalRef.hide();
  }

  public onCancel(): void {
    this.onClose.next(true);
    this._bsModalRef.hide();
  }

  public hideConfirmationModal(): void {
    this.onClose.next(null);
    this._bsModalRef.hide();
  }

}
